import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Paper,
  Tab,
  Tabs
} from '@material-ui/core';

import ExpensesTable from 'components/Expenses/ExpensesTable';
import ExpenseDetails from 'components/Expenses/ExpenseDetails';
import ExpenseTypesTable from 'components/Expenses/ExpenseTypesTable';
import ExpenseInvoice from 'components/Invoices/ExpenseInvoice';

import { admin, standard } from 'variables/userAccountTypes';

const ExpenseListResults = (props) => {

  const printRef = useRef();

  const [tabValue, setTabValue] = useState(0);
  const [userTabValue, setUserTabValue] = useState(0);

  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [invoiceBuffer, setInvoiceBuffer] = useState({});

  const adminObj = [{id: props.activeUserId, name: props.user.name}];
  const usersArray = adminObj.concat(props.user.standard_users);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Expense Invoice"
  });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setUserTabValue(0);
  };

  const handleUserTabChange = (event, newValue) => {
    setUserTabValue(newValue);
  };
  
  const handleInvoiceModalOpen = (invoiceInfo) => {
    setOpenInvoiceModal(true);
    setInvoiceBuffer(invoiceInfo);
  };

  const handleInvoiceModalClose = () => {
    setOpenInvoiceModal(false);
    setInvoiceBuffer({});
  };

  const createExpenseDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.expense;
    let expenseNum;
    length < 100 ? 
      expenseNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : expenseNum = length
    return ("EXP-" + expenseNum);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <Paper>
          <Tabs
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleTabChange}
            centered
          >
            <Tab label="Expenses" />
            <Tab label="New Expense" />
            {/* standard users do not have access to modify expense types */
            !(props.activeUserType === standard) ?
            <Tab label="Expense Types" /> : null }
          </Tabs>
        </Paper>
      </Box>
      { tabValue === 0 ?
      /* if the user account type is admin, show expenses of all users,
        else show expenses of only that user. */
      ( props.activeUserType === admin ?
        <Box>
          <Box
            sx={{
              display: 'flex'
            }}
          >
            <Paper>
              <Tabs
                value={userTabValue}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleUserTabChange}
                centered
              >
                {usersArray.map((user) => (<Tab key={user.id} label={user.name} />))}
              </Tabs>
            </Paper>
          </Box>
          <Box marginTop={1}>
            <ExpensesTable
              userTabValue={userTabValue}
              usersArray={usersArray}
              activeUserType={props.activeUserType}
              expenses={props.expenses}
            />
          </Box>
        </Box> :
        <Box marginTop={1}>
          <ExpensesTable
            activeUserType={props.activeUserType}
            expenses={props.expenses}
          />
        </Box>
      ) : null }
      { tabValue === 1 ?
        <Box marginTop={1}>
          <ExpenseDetails
            activeUserId={props.activeUserId}
            activeUserType={props.activeUserType}
            expenseTypes={props.expenseTypes}
            employees={props.employees}
            user={props.user}
            setTabValue={setTabValue}
            createExpenseDisplayId={createExpenseDisplayId}
            openModal={handleInvoiceModalOpen}
          />
        </Box>
      : null }
      { tabValue === 2 ?
        <Box marginTop={1}>
          <ExpenseTypesTable
            expenseTypes={props.expenseTypes}
            expenses={props.expenses}
          />
        </Box>
      : null }
      { openInvoiceModal ?
        <Modal open={openInvoiceModal} >
          <Card>
            <CardHeader
              subheader="Please Review The Invoice"
              title="Print Invoice"
            />
            <Divider />
            <CardContent>
              <Box>
                <Paper
                  style={{
                    overflow: 'auto',
                    maxHeight: 462
                  }}
                >
                  <ExpenseInvoice
                    ref={printRef}
                    info={invoiceBuffer}
                    user={props.user}
                  />
                </Paper>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '1%'
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {
                      handlePrint();
                      handleInvoiceModalClose();
                    }}
                  >
                    Print Invoice
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Modal>
      : null }
    </Box>
  )
};

export default ExpenseListResults;
